import React from 'react';
import { Button, Card, CardBody } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import { FaPencilAlt } from 'react-icons/fa';

interface BeTheFirstReviewerProps {
  foodName: string;
  onAddReview: () => void;
}

export const BeTheFirstReviewer: React.FC<BeTheFirstReviewerProps> = ({
  foodName,
  onAddReview,
}) => {
  const { t } = useTranslation();

  return (
    <Card className="bg-primary-50 border border-primary-200 shadow-lg dark:bg-primary-900/30 dark:border-primary-700">
      <CardBody className="flex flex-col items-center justify-center text-center p-6 sm:p-8 gap-4">
        <h3 className="text-xl sm:text-2xl font-semibold text-primary-800 dark:text-primary-200">
          {t('food.beTheFirstReviewer.title', { foodName })}
        </h3>
        <p className="text-sm sm:text-base text-foreground/80 dark:text-foreground/70 max-w-md">
          {t('food.beTheFirstReviewer.description')}
        </p>
        <Button
          size="lg"
          color="primary"
          onPress={onAddReview}
          startContent={<FaPencilAlt />}
          className="mt-4 shadow-md hover:shadow-lg transition-shadow text-wrap"
        >
          {t('food.beTheFirstReviewer.button')}
        </Button>
      </CardBody>
    </Card>
  );
}; 